import { Component, computed, inject, input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { CellOverlayAction } from '@shared/components/table/table-cell/actions-overlay/actions-overlay.component';
import { TableCellDataType } from '@shared/components/table/table-cell/table-cell-data-type';
import {
  formatCellValue,
  processWindowValue
} from '@shared/components/table/table-cell/utils';

@Component({
  selector: 'app-window-cell',
  imports: [],
  templateUrl: './window-cell.component.html'
})
export class WindowCellComponent {
  private readonly translate = inject(TranslateService);

  availableCellActions: CellOverlayAction[] = ['copy'];
  availableCellShiftActions: CellOverlayAction[] = ['copy_raw'];
  valueAsString = (v: unknown) =>
    formatCellValue(
      v,
      `${this.type()}-window` as TableCellDataType,
      this.translate.getCurrentLang()
    );

  type = input<'time' | 'date' | 'datetime'>('time');
  value = input<unknown | undefined>(undefined);

  protected processedValue = computed<string>(() =>
    processWindowValue(this.value(), this.type(), this.translate.getCurrentLang())
  );
}
